import { useEffect, useState } from 'react';
import { getBuybackData } from '../../../shared/services/apiGateway';

function useBuybackData(userid = '') {
  const [buybackData, setBuybackData] = useState(null);

  useEffect(() => {
    const abortController = new AbortController();
    let ignore = false;

    async function fetchData() {
      const response = await getBuybackData(userid, abortController.signal);
      if (!ignore && response !== 'aborted' && response) {
        setBuybackData(response);
      }
    }

    fetchData();

    return () => {
      ignore = true;
      abortController.abort();
    };
  }, [userid]);

  return buybackData;
}

export default useBuybackData;

